/**
 * ACIL Intelligence - Error 500 (Server Error)
 */
import { Link } from 'react-router-dom';
import { AlertOctagon } from 'lucide-react';

export default function Error500() {
  return (
    <div className="error-page" data-testid="error-500-page">
      <AlertOctagon size={48} color="var(--danger)" style={{ marginBottom: 16 }} />
      <div className="error-code" style={{ color: 'var(--danger)' }}>500</div>
      <div className="error-title">Error del servidor</div>
      <div className="error-text">
        Ocurrio un error inesperado. Intenta de nuevo en unos momentos.
      </div>
      <Link to="/dashboard" className="btn-primary" style={{ textDecoration: 'none' }} data-testid="error-500-home-btn">
        Ir al dashboard
      </Link>
    </div>
  );
}
